module.exports = __webpack_public_path__ + "static/media/wrong-ipv-two.91a91d32.svg";